import React from "react";
import { useRegUIClient } from "@foundation/reg-ui-client";
import { BoxAd } from "@bloomberg/media-ui-ads";
import styles from "./watchlistLayout.module.css";
import AnonymousUser from "~components/Portfolio/AnonymousUser";
import RegisteredUser from "~components/Portfolio/RegisteredUser";
import PortfolioLoadingState from "~components/Portfolio/PortfolioLoadingState";
import WatchlistNews from "~components/Portfolio/WatchlistNews";
import CenterRightLayout from "~components/CenterRightLayout";
import {
  PortfolioPageProvider,
  usePortfolioPage,
} from "~context/PortfolioPageContext";
import PortfolioView from "~components/Portfolio/PortfolioView";
import { AbbaProviderWithUserInfo } from "~components/AbbaProviderWithUserInfo";

function WatchlistBoxAd() {
  const { selectedPortfolio } = usePortfolioPage();

  if (!selectedPortfolio?.positions.length) {
    return null;
  }

  return <BoxAd className={styles.ad} flexSizeAllowed />;
}

export default function WatchlistPageLayout() {
  const { session } = useRegUIClient();

  const userView = session?.isLoggedIn ? <RegisteredUser /> : <AnonymousUser />;

  return (
    <PortfolioPageProvider>
      <AbbaProviderWithUserInfo platform="watchlist">
        <div className={styles.gridLayoutContainer}>
          {session?.isRegUIClientLoaded ? userView : <PortfolioLoadingState />}
          <PortfolioView showLots />
          <CenterRightLayout
            contentWell={<WatchlistNews />}
            rightRail={<WatchlistBoxAd />}
          />
        </div>
        {/* Plug-in client placeholder */}
        <div className="plug-banner" />
      </AbbaProviderWithUserInfo>
    </PortfolioPageProvider>
  );
}
